import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Solutions from './components/Solutions';
import CaseStudies from './components/CaseStudies';
import Company from './components/Company';
import Contact from './components/Contact';
import Navigation from './components/Navigation';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Services />
      <Solutions />
      <CaseStudies />
      <Company />
      <Contact />
    </div>
  );
}